import { Link } from 'react-router-dom';

const milestones = [
  { year: '2018', title: '平台创立', desc: '91下载正式上线，以"安全极速"为核心理念，致力于为用户提供优质的软件下载服务。' },
  { year: '2019', title: '百万用户', desc: '注册用户突破100万，收录软件超过5,000款，覆盖办公、游戏、工具等多个领域。' },
  { year: '2020', title: '安全升级', desc: '引入多重安全检测引擎，与国内外知名安全厂商合作，实现100%上架软件安全扫描。' },
  { year: '2021', title: '极速体验', desc: '部署全球CDN加速节点，下载速度提升300%，用户平均下载等待时间缩短至秒级。' },
  { year: '2023', title: '千万用户', desc: '累计用户突破1000万，日活跃用户超过200万，成为中文互联网领先的下载平台。' },
  { year: '2025', title: 'AI赋能', desc: '引入AI智能推荐算法，根据用户偏好精准匹配软件资源，打造个性化下载体验。' },
];

const faqs = [
  { q: '91下载上的软件是否安全可靠？', a: '是的。我们与国内外知名软件厂商合作，所有上架软件均经过多重安全引擎扫描检测，确保无毒无捆绑。下载过程中不会植入任何广告插件或推广内容。' },
  { q: '下载的软件是否需要付费？', a: '91下载平台上的绝大多数软件均为免费正版。部分商业软件提供官方试用版下载，如需购买正版授权，我们会引导用户前往软件官方网站完成购买。' },
  { q: '下载速度慢怎么办？', a: '我们部署了全球CDN加速节点，正常情况下下载速度可达带宽上限。如遇下载缓慢，建议检查本地网络环境，或尝试切换下载线路。也可联系客服获取专属高速通道。' },
  { q: '如何反馈软件问题或提交收录申请？', a: '您可以通过客服邮箱 support@91xiazai.com 或在线客服渠道提交反馈。软件开发者如需将产品上架至91下载，可发送邮件至合作邮箱，我们会在3个工作日内完成审核。' },
  { q: '91下载支持哪些操作系统？', a: '目前平台主要提供Windows系统的软件下载服务。macOS、Linux及移动端应用的下载服务正在规划中，敬请期待。' },
];

export default function AboutPage() {
  return (
    <main className="pt-16">
      {/* Breadcrumb */}
      <div className="bg-background-100 border-b border-background-200/70">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-3">
          <nav className="flex items-center gap-2 text-xs text-foreground-500" aria-label="面包屑导航">
            <Link to="/" className="hover:text-primary-500 transition-colors">首页</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-foreground-800 font-medium">关于我们</span>
          </nav>
        </div>
      </div>

      {/* Hero */}
      <section className="max-w-7xl mx-auto px-4 md:px-6 pt-14 pb-10">
        <div className="text-center max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">关于91下载</h1>
          <p className="text-base text-foreground-600 leading-relaxed">
            91下载成立于2018年，是国内领先的软件资源下载平台。我们始终坚持"安全、极速、绿色、免费"的服务理念，为亿万用户提供高质量的正版软件、游戏和工具类应用下载服务。
          </p>
        </div>
      </section>

      {/* Brand Values */}
      <section className="max-w-7xl mx-auto px-4 md:px-6 pb-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {[
            { icon: 'ri-star-line', title: '使命', desc: '让每一个用户都能安全、便捷地获取所需软件资源，消除软件下载中的安全隐患和繁琐步骤。' },
            { icon: 'ri-eye-line', title: '愿景', desc: '成为中文互联网最值得信赖的软件下载平台，构建健康、透明的软件分发生态。' },
            { icon: 'ri-heart-line', title: '价值观', desc: '用户至上、安全第一、创新驱动、合作共赢。我们视每一次下载为一份信任。' },
          ].map((item) => (
            <div key={item.title} className="bg-background-50 border border-background-200/70 rounded-xl p-6 text-center">
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-primary-50 text-primary-500 mb-4">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="text-lg font-heading font-bold text-foreground-950 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Milestones */}
      <section className="bg-background-100 py-14">
        <div className="max-w-4xl mx-auto px-4 md:px-6">
          <h2 className="text-2xl font-heading font-bold text-foreground-950 text-center mb-10">发展历程</h2>
          <div className="relative">
            <div className="absolute left-[19px] top-2 bottom-2 w-0.5 bg-background-300 md:left-1/2 md:-translate-x-px"></div>
            <div className="space-y-8">
              {milestones.map((m, idx) => (
                <div key={m.year} className={`relative flex items-start gap-6 ${idx % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'}`}>
                  <div className="flex-shrink-0 relative z-10 w-10 h-10 rounded-full bg-primary-500 text-white flex items-center justify-center font-heading font-bold text-xs md:mx-auto md:absolute md:left-1/2 md:-translate-x-1/2">
                    {m.year.slice(2)}
                  </div>
                  <div className={`flex-1 ${idx % 2 === 0 ? 'md:text-right md:pr-16' : 'md:text-left md:pl-16'}`}>
                    <div className="bg-background-50 border border-background-200/70 rounded-xl p-5 inline-block text-left max-w-md">
                      <div className="text-xs font-bold text-primary-500 mb-1">{m.year}</div>
                      <h3 className="text-base font-semibold text-foreground-950 mb-1">{m.title}</h3>
                      <p className="text-sm text-foreground-500 leading-relaxed">{m.desc}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Contact */}
      <section className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <h2 className="text-2xl font-heading font-bold text-foreground-950 text-center mb-10">联系我们</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
          {[
            { icon: 'ri-mail-line', title: '客服邮箱', value: 'support@91xiazai.com', desc: '7x24小时在线响应' },
            { icon: 'ri-phone-line', title: '客服热线', value: '400-888-9191', desc: '工作日 9:00-18:00' },
            { icon: 'ri-map-pin-line', title: '公司地址', value: '北京市海淀区中关村软件园', desc: '91下载网络科技有限公司' },
          ].map((c) => (
            <div key={c.title} className="bg-background-50 border border-background-200/70 rounded-xl p-6 text-center">
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-accent-50 text-accent-500 mb-4">
                <i className={`${c.icon} text-xl`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-950 mb-1">{c.title}</h3>
              <p className="text-sm text-primary-600 font-medium mb-1">{c.value}</p>
              <p className="text-xs text-foreground-400">{c.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* FAQ */}
      <section className="bg-background-100 py-14">
        <div className="max-w-3xl mx-auto px-4 md:px-6">
          <h2 className="text-2xl font-heading font-bold text-foreground-950 text-center mb-10">常见问题</h2>
          <div className="space-y-4">
            {faqs.map((faq, idx) => (
              <details key={idx} className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden cursor-pointer">
                <summary className="flex items-center justify-between p-5 font-medium text-foreground-900 text-sm list-none">
                  <span>{faq.q}</span>
                  <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform text-lg"></i>
                </summary>
                <div className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">{faq.a}</div>
              </details>
            ))}
          </div>
        </div>
      </section>

      {/* Schema.org JSON-LD */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '91下载',
            url: 'https://www.91xiazai.com/',
            description: '91下载是国内领先的软件资源下载平台，提供海量正版软件、游戏、工具类应用的极速下载服务。',
            foundingDate: '2018',
            email: 'support@91xiazai.com',
            telephone: '400-888-9191',
            address: {
              '@type': 'PostalAddress',
              addressLocality: '北京市',
              addressRegion: '海淀区',
              streetAddress: '中关村软件园',
              addressCountry: 'CN',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqs.map((faq) => ({
              '@type': 'Question',
              name: faq.q,
              acceptedAnswer: { '@type': 'Answer', text: faq.a },
            })),
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: '首页', item: 'https://www.91xiazai.com/' },
              { '@type': 'ListItem', position: 2, name: '关于我们', item: 'https://www.91xiazai.com/about' },
            ],
          }),
        }}
      />
    </main>
  );
}